// assets
import { IconBell, IconLanguage, IconPalette, IconReceipt2, IconWebhook, IconHome, IconWorld } from '@tabler/icons-react';

// types
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS - SETTINGS ||============================== //
// C-2: the platform tenant-management console (Overview + Tenants) moved to the dedicated
// super-admin SPA. What remains here is the tenant's OWN branding — a legitimate admin
// setting (controlplane.branding.write), so it lives under Settings now, not "Platform".

const settings: NavItemType = {
  id: 'settings',
  title: 'settings', // react-intl key (utils/locales/en.json) - i18n-ready [STD-DRIFT]
  icon: IconPalette,
  type: 'group',
  children: [
    {
      id: 'settings-branding',
      title: 'platform-branding',
      icon: IconPalette,
      type: 'item',
      url: '/settings/branding',
      module: 'controlplane.branding'
    },
    {
      // DOC-ISS2: teklif/proforma/makbuz/fatura antedi ve numara serileri. Commerce'ten BURAYA taşındı.
      //
      // ⚠ `module:` DEĞİL `permission:`. Modül kapısı "documents üzerinde HERHANGİ bir yetki" demektir,
      // yani yalnız .view taşıyan biri de ayar ekranını görür ve kaydederken 403 alır. Anteti ve seriyi
      // değiştirmek dar ve ayrı bir yetkidir.
      //
      // ⚠ Yetki hâlâ COMMERCE'in: Ayarlar altında dursa da veriyi Commerce tutuyor. Commerce modülünü
      // kapatmak bu Ayarlar satırını da gizler; kabul edilen bir tuhaflık, alternatifi Ayarlar tarafına
      // ikinci bir menü yetkisi ihdas etmek olurdu ([STD-DRIFT] üçlüsü + seed migration).
      id: 'settings-document-issuer',
      title: 'commerce-document-issuer-profile',
      icon: IconReceipt2,
      type: 'item',
      url: '/settings/document-issuer',
      permission: 'commerce.documents.issuer_profile'
    },
    {
      id: 'settings-integrations',
      title: 'settings-integrations',
      icon: IconWebhook,
      type: 'item',
      url: '/settings/integrations',
      module: 'identity.integrations'
    },
    {
      id: 'settings-notifications',
      title: 'settings-notifications',
      icon: IconBell,
      type: 'item',
      url: '/settings/notifications',
      module: 'notif.preferences'
    },
    {
      id: 'settings-locale',
      title: 'settings-locale',
      icon: IconLanguage,
      type: 'item',
      url: '/settings/locale',
      module: 'controlplane.branding'
    },
    {
      // SITE-CMS D9: kiracının KENDİ genel sayfaları. Marka ile aynı modül ÇÜNKÜ aynı izni kullanır
      // (controlplane.branding.update) ve sunucuda aynı TenantScopedWriteAccess kapısından geçer.
      //
      // ⚠ PLATFORMUN VARSAYILAN SİTESİ BURADA DEĞİL. O satırın kiracısı yok, dolayısıyla sahibi de
      // yok; onu super-admin /public-site düzenler ve platform_admin ister. Bu ekran yalnızca
      // çağıranın kendi kiracısını hedefler.
      id: 'settings-site',
      title: 'settings-site',
      icon: IconWorld,
      type: 'item',
      url: '/settings/site',
      module: 'controlplane.branding'
    },
    {
      // LAND-CFG: marka ile AYNI modül — açılış sayfası da marka ayarıdır (extras torbası).
      id: 'settings-landing',
      title: 'settings-landing',
      icon: IconHome,
      type: 'item',
      url: '/settings/landing',
      module: 'controlplane.branding'
    }
  ]
};

export default settings;
